import React from 'react';
import InputLabel from "@material-ui/core/InputLabel";
import {MenuItem, Select, FormHelperText, Chip, OutlinedInput,InputAdornment,IconButton} from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import {styles} from "../inputComponents/inputStyle";
import MultipleSelect from '../inputComponents/multiple'
import {InputError} from "../index";

// import {makeStyles, useTheme} from '@material-ui/core/styles';

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

function Input(props) {

  const {
    item = {},
    onChange, classes
  } = props;
  // console.log({item})
  const {
    id = '',
    type = 'text',
    label,
    labelWidth = 53,
    dropdownList = [],
    errorText,
    placeholder,
    value,
    error = '',
    required = false,
    min = 0, max,
    disable = false,
    defaultValue = '',
    title = ''
  } = item;

  return (
    <div>
      <InputLabel htmlFor={id} className='mb-10' error={error}>{label}</InputLabel>
      {
        (item?.type === 'select') ?
          <>
            {item?.multipleValues === true ?
              <MultipleSelect item={item} value={value} onChange={(value, id) => {
                onChange(value, id)
              }} dropdownList={dropdownList}/>
              :
              <Select
                // variant='outlined'
                displayEmpty={true}
                required={required}
                id={id || label}
                value={value}
                onChange={(event) => {
                  onChange(event.target.value, id || label)
                }}
                error={error}
                fullWidth
                margin='normal'
                // label={label}
                // labelWidth={labelWidth}
                // multiple={true}
                placeholder={'select '}
                disabled={disable}
                defaultValue={defaultValue}
                InputProps={{
                  classes: {
                    root: classes.cssOutlinedInput,
                    focused: classes.cssFocused,
                    notchedOutline: classes.notchedOutline,
                  },
                }}
              >
                {/*https://deep-0301.github.io/multi-step-form/*/}
                {/*https://github.com/deep-0301/multi-step-form*/}
                <MenuItem value="" disabled>
                  <em className='text-capitalize ' style={{color: '#9B9C9D', fontStyle: 'normal'}}>{placeholder || title || label} </em>
                </MenuItem>
                {dropdownList.map((val, index) => (
                  <MenuItem className='text-capitalize' value={val.value}
                            key={`${val.value + index}`}>{val.text}</MenuItem>
                ))}
              </Select>}
            {/*{error && <FormHelperText className='error-class'>{error}</FormHelperText>}*/}
          </>
          :
          <OutlinedInput
            disabled={disable}
            id={id || label}
            type={type}
            value={value}
            variant="outlined"
            // margin="normal"
            required={required}
            fullWidth
            defaultValue={defaultValue}
            error={error}
            placeholder={type === 'email' ? 'username' : placeholder || label || id}
            onChange={(event) =>
              onChange(event.target.value, id || label)
            }
            // className={classes.textField}
            InputProps={{
              inputProps: {min: min, max},
              classes: {
                root: classes.cssOutlinedInput,
                focused: classes.cssFocused,
                notchedOutline: classes.notchedOutline,
              },
            }}
            endAdornment={
              id == 'email' ? <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  edge="end"
                >
                  <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                      <g id="user 1">
                      <g id="Group">
                      <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M9.18395 3.54395C7.21645 3.54395 5.62146 5.13893 5.62146 7.10645C5.62146 9.07397 7.21645 10.6689 9.18395 10.6689C11.1515 10.6689 12.7465 9.07397 12.7465 7.10645C12.7465 5.13893 11.1515 3.54395 9.18395 3.54395ZM6.74646 7.10645C6.74646 5.76026 7.83778 4.66895 9.18395 4.66895C10.5301 4.66895 11.6215 5.76026 11.6215 7.10645C11.6215 8.45267 10.5301 9.54392 9.18395 9.54392C7.83778 9.54392 6.74646 8.45267 6.74646 7.10645Z" fill="#92929D"/>
                      <path id="Vector_2" fill-rule="evenodd" clip-rule="evenodd" d="M9.39747 1.12908C9.25504 1.12201 9.11232 1.12201 8.96982 1.12908C8.41977 1.15639 7.91344 1.31621 7.34892 1.57817C6.79938 1.83318 6.16081 2.20187 5.35293 2.6683L5.30717 2.69472C4.49929 3.16115 3.86071 3.52983 3.36508 3.87823C2.85598 4.23612 2.46439 4.59474 2.16573 5.05742C2.08836 5.17728 2.017 5.30089 1.95188 5.42781C1.70052 5.9178 1.58574 6.43624 1.53035 7.05609C1.47643 7.65951 1.47644 8.39688 1.47644 9.32973V9.3826C1.47644 10.3155 1.47643 11.0528 1.53035 11.6562C1.58574 12.276 1.70052 12.7945 1.95188 13.2845C2.01699 13.4115 2.08836 13.5351 2.16573 13.6549C2.53192 14.2222 3.03948 14.6347 3.73099 15.0793C4.16302 15.357 4.68863 15.6605 5.31931 16.0246L5.35291 16.044C6.1608 16.5105 6.79937 16.8792 7.34892 17.1342C7.91344 17.3961 8.41977 17.5559 8.96982 17.5833C9.11232 17.5903 9.25504 17.5903 9.39747 17.5833C9.94752 17.5559 10.4539 17.3961 11.0184 17.1342C11.568 16.8792 12.2065 16.5105 13.0144 16.044L13.0485 16.0243C13.6851 15.6568 14.2147 15.351 14.6492 15.071C15.3341 14.6296 15.8376 14.2188 16.2015 13.6549C16.2789 13.5351 16.3503 13.4115 16.4154 13.2845C16.6668 12.7945 16.7816 12.276 16.8369 11.6562C16.8909 11.0528 16.8909 10.3155 16.8909 9.3826V9.32973C16.8909 8.39688 16.8909 7.65951 16.8369 7.05609C16.7816 6.43624 16.6668 5.9178 16.4154 5.42781C16.3503 5.30089 16.2789 5.17727 16.2015 5.05742C15.9029 4.59474 15.5113 4.23612 15.0022 3.87823C14.5066 3.52983 13.868 3.16115 13.0602 2.69472L13.0143 2.6683C12.2065 2.20187 11.5679 1.83318 11.0184 1.57817C10.4539 1.31621 9.94752 1.15639 9.39747 1.12908ZM9.02562 2.2527C9.13092 2.24747 9.23637 2.24747 9.34174 2.2527C9.69634 2.27031 10.0559 2.37175 10.5448 2.59864C11.0435 2.83006 11.639 3.17325 12.4748 3.65579C13.3105 4.13834 13.9055 4.48242 14.3553 4.79859C14.7962 5.10856 15.0639 5.36924 15.2564 5.66754C15.3135 5.75613 15.3663 5.8475 15.4144 5.94131C15.5765 6.25722 15.6684 6.61935 15.7164 7.15621C15.7653 7.7038 15.7659 8.39103 15.7659 9.35613C15.7659 10.3212 15.7653 11.0085 15.7164 11.5561C15.6684 12.093 15.5765 12.4551 15.4144 12.771C15.3663 12.8648 15.3135 12.9562 15.2564 13.0448C15.1028 13.2827 14.9021 13.496 14.6039 13.7298C14.013 12.5804 12.8157 11.7936 11.4336 11.7936H6.93365C5.55154 11.7936 4.35424 12.5804 3.76343 13.7298C3.4652 13.4961 3.26452 13.2828 3.11092 13.0448C3.05373 12.9562 3.00098 12.8648 2.95285 12.771C2.79079 12.4551 2.69886 12.093 2.65089 11.5561C2.60196 11.0085 2.60144 10.3212 2.60144 9.35613C2.60144 8.39103 2.60196 7.7038 2.65089 7.15621C2.69886 6.61935 2.79079 6.25722 2.95285 5.94131C3.00098 5.8475 3.05373 5.75613 3.11092 5.66754C3.30347 5.36924 3.57112 5.10856 4.01206 4.79859C4.46182 4.48242 5.05675 4.13834 5.89255 3.65579C6.72834 3.17325 7.32379 2.83006 7.82247 2.59864C8.31139 2.37175 8.67094 2.27031 9.02562 2.2527ZM11.4336 12.9186C12.4252 12.9186 13.2795 13.5111 13.6601 14.3622C13.3266 14.5647 12.937 14.7897 12.4748 15.0565C11.639 15.5391 11.0435 15.8823 10.5448 16.1137C10.0559 16.3406 9.69634 16.442 9.34174 16.4596C9.23637 16.4649 9.13092 16.4649 9.02562 16.4596C8.67094 16.442 8.31139 16.3406 7.82247 16.1137C7.32379 15.8823 6.72834 15.5391 5.89255 15.0565C5.43034 14.7897 5.04079 14.5647 4.7072 14.3622C5.08772 13.5111 5.94208 12.9186 6.93365 12.9186H11.4336Z" fill="#92929D"/>
                      </g>
                      </g>
                    </svg>
                  </div>
                </IconButton>
              </InputAdornment> : null
            }
            // labelWidth={labelWidth}
          />
      }
      {/*error message*/}
      {error && <InputError message={error}/>}
    </div>
  );
}

export default withStyles(styles)(Input);

// export default withStyles(styles)(Input);
//
// import React from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
// import MenuItem from '@material-ui/core/MenuItem';
//
// import OutlinedInput from "@material-ui/core/OutlinedInput";
// import TextField from '@material-ui/core/TextField';
//
// const styles = theme => ({
//   container: {
//     display: 'flex',
//     flexWrap: 'wrap',
//   },
//   textField: {
//     marginLeft: theme.spacing.unit,
//     marginRight: theme.spacing.unit,
//     width: 200,
//   },
//
//   cssLabel: {
//     color : 'green'
//   },
//
//   cssOutlinedInput: {
//     '&$cssFocused $notchedOutline': {
//       // borderColor: `${theme.palette.primary.main} !important`,
//       borderColor: ` red !important`,
//     }
//   },
//
//   cssFocused: {},
//
//   notchedOutline: {
//     borderWidth: '1px',
//     borderColor: 'green !important'
//   },
//
// });
//
// class ValidField extends React.Component {
//   state = {
//     name: 'InputMode',
//   };
//
//   handleChange = name => event => {
//     this.setState({
//       [name]: event.target.value,
//     });
//   };
//
//   render() {
//     const { classes,item } = this.props;
//     const {
//     id,
//     type = 'text',
//     label,
//     labelWidth = 53,
//     dropdownList = [],
//     errorText,
//     value,
//     error,
//     required = false,
//     min, max,
//     disable = false,
//     defaultValue = '',
//   } = item;
//
//     return (
//       // <form className={classes.container} noValidate autoComplete="off">
//         <TextField
//           id="standard-name"
//           label="Name"
//           className={classes.textField}
//           value={this.state.name}
//           onChange={this.handleChange('name')}
//           margin="normal"
//           variant="outlined"
//           InputLabelProps={{
//             classes: {
//               root: classes.cssLabel,
//               focused: classes.cssFocused,
//             },
//           }}
//           InputProps={{
//             classes: {
//               root: classes.cssOutlinedInput,
//               focused: classes.cssFocused,
//               notchedOutline: classes.notchedOutline,
//             },
//             inputMode: "numeric"
//           }}
//         />
//       // </form>
//     );
//   }
// }
//
// ValidField.propTypes = {
//   classes: PropTypes.object.isRequired,
// };
//
// export default withStyles(styles)(ValidField);
